<div siqGrid [fx-direction]="btnsDirection" [fx-direction-lt-sm]="mediumScreen"  [fx-direction-xs]="smallScreen">
  <div class="cursor-pointer app-store-white-icon" (click)="openStoreLink(0)"></div>
  <div [class]="googlePlayStoreBtnClasses" (click)="openStoreLink(1)"></div>
</div>